import { Store } from "src/store";
import toggleOS from "src/sdk/toggleOS";
import { openTradeIn as openTradeInAction } from "src/store/actions/tradeIn";

async function openTradeIn(store: Store, vin: string) {
    await store.dispatch(openTradeInAction(vin));
    await toggleOS(store, vin);
}

export default openTradeIn;
